// extracted by mini-css-extract-plugin
export default {"wrap":"DateProgress_wrap__hqRWr","date":"DateProgress_date__QT5-g","progress":"DateProgress_progress__U5JoO"};